import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPSixFoldSignificatorCuspalView } from './KPSixFoldSignificatorCuspalView';
import { KPSixFoldSignificatorPlanetView } from './KPSixFoldSignificatorPlanetView';

export function KPSixFoldSignificatorChart ({menuArray,userData}) {
  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[4]} className="m-0 p-0 ">
              <Row id="planetSignificatorsChart" className="m-0 p-0">
                  <Col xs={12} md={6} className="p-2 pt-0 m-0">
                    <KPSixFoldSignificatorCuspalView userData={userData}/>
                  </Col>
                  <Col xs={12} md={6} className="p-2 pb-0 pt-0 m-0">
                    <KPSixFoldSignificatorPlanetView userData={userData}/>
                  </Col>
              </Row>
          </Collapse>
    }
  </>  
  );
}